export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-orange-600 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/0eec0f6b43802b90423f55e0902fba48/3c15690f72a27a0597e9647a1121ce97.png" 
                alt="Nationwide Pallet Solution" 
                className="h-10 w-auto"
              />
            </div>
            <h3 className="text-lg font-bold mb-3">Nationwide Pallet Solution</h3>
            <p className="text-orange-100 text-sm leading-relaxed">
              Your trusted partner for premium pallets delivered nationwide. Quality, reliability, and service excellence since 2021.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-orange-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-orange-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('catalog')}
                  className="text-orange-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  Product Catalog
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-orange-100 hover:text-white transition-colors text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Products</h4>
            <ul className="space-y-2 text-sm text-orange-100">
              <li>48x40 Standard Pallets</li>
              <li>Custom Size Pallets</li>
              <li>Heavy Duty Pallets</li>
              <li>GMA Pallets</li>
              <li>Recycled Pallets</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <i className="ri-phone-line text-orange-100 mr-2 mt-1"></i>
                <a href="tel:+13183152367" className="text-orange-100 hover:text-white transition-colors">
                  (318) 315-2367
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-orange-100 mr-2 mt-1"></i>
                <a href="mailto:Lamar@NationwidePalletSolution.com" className="text-orange-100 hover:text-white transition-colors">
                  Lamar@NationwidePalletSolution.com
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-orange-100 mr-2 mt-1"></i>
                <span className="text-orange-100">
                  Shreveport, La 71108
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-orange-500 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-orange-100 text-sm mb-4 md:mb-0">
            © 2024 Nationwide Pallet Solution. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-orange-100 hover:text-white text-sm transition-colors"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}